import { createContext } from "react";

const ThemeContext = createContext(["default", () => {}]);

export default ThemeContext;
